
export default function TrustSignals() {
  const signals = [
    {
      icon: 'ri-shield-check-line',
      number: '18+',
      label: 'Years Experience',
      description: 'Serving Watford & Hertfordshire',
      color: 'text-amber-600'
    },
    {
      icon: 'ri-user-heart-line',
      number: '500+',
      label: 'Happy Customers',
      description: 'Across local areas',
      color: 'text-sky-600'
    },
    {
      icon: 'ri-star-fill',
      number: '4.9',
      label: 'Average Rating',
      description: 'From verified reviews',
      color: 'text-amber-600'
    },
    {
      icon: 'ri-shield-star-line',
      number: '100%',
      label: 'Fully Insured',
      description: '£1M public liability',
      color: 'text-sky-600'
    }
  ];

  return (
    <section className="py-16 px-6 bg-white border-b border-beige-200">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {signals.map((signal, index) => (
            <div key={index} className="text-center">
              <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center">
                <i className={`${signal.icon} text-5xl ${signal.color}`}></i>
              </div>
              <div className="text-4xl font-bold text-neutral-700 mb-2">
                {signal.number}
              </div>
              <div className="text-base font-semibold text-neutral-800 mb-1">
                {signal.label}
              </div>
              <div className="text-sm text-neutral-600">
                {signal.description}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
